module.exports = __webpack_public_path__ + "img/644-d779e5.png";